import { useAuthStore } from '@/store/authStore';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

interface RegisterData {
  username: string;
  password: string;
  email?: string;
}

interface LoginData {
  username: string;
  password: string;
}

interface UserPreference {
  genre?: string;
  artist?: string;
  familiarityLevel: number;
}

// 获取认证 header
function getAuthHeader(): HeadersInit {
  const token = useAuthStore.getState().token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// 注册
export async function register(data: RegisterData) {
  const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '注册失败');
  }
  
  return response.json();
}

// 登录
export async function login(data: LoginData) {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '登录失败');
  }
  
  return response.json();
}

// 获取当前用户信息
export async function getCurrentUser() {
  const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
    headers: {
      ...getAuthHeader(),
    },
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '获取用户信息失败');
  }
  
  return response.json();
}

// 保存用户偏好
export async function saveUserPreferences(preferences: UserPreference[]) {
  const response = await fetch(`${API_BASE_URL}/api/auth/preferences`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeader(),
    },
    body: JSON.stringify({ preferences }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '保存偏好失败');
  }
  
  return response.json();
}

// 获取用户偏好
export async function getUserPreferences() {
  const response = await fetch(`${API_BASE_URL}/api/auth/preferences`, {
    headers: {
      ...getAuthHeader(),
    },
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '获取偏好失败');
  }
  
  return response.json();
}

